import { SvgIcon } from '@mui/material';

export const IconLogout = () => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24">
    <path d="M11.47,14.47l-.53.53L12,16.06l.53-.53ZM15,12l.53.53a.75.75,0,0,0,0-1.06ZM12.53,8.47,12,7.94,10.94,9l.53.53ZM4,11.25H3.25v1.5H4Zm8.53,4.28,3-3-1.06-1.06-3,3Zm3-4.06-3-3L11.47,9.53l3,3ZM4,12.75H15v-1.5H4Z" />
    <path d="M19,20.75H10A1.76,1.76,0,0,1,8.25,19V17a.75.75,0,0,1,1.5,0v2a.25.25,0,0,0,.25.25h9a.25.25,0,0,0,.25-.25V5A.25.25,0,0,0,19,4.75H10A.25.25,0,0,0,9.75,5V7a.75.75,0,0,1-1.5,0V5A1.76,1.76,0,0,1,10,3.25h9A1.76,1.76,0,0,1,20.75,5V19A1.76,1.76,0,0,1,19,20.75Z" />
  </SvgIcon>
);
